import { formatWalletAwardNumericDate } from './formatWalletAwardNumericDate';

export const buildWalletAwardExpirationText = (
  expiresLabel: string | undefined,
  expirationDate: string | undefined,
  locale: string
): string | undefined => {
  if (!expirationDate || !expiresLabel) {
    return undefined;
  }

  return `${expiresLabel} ${formatWalletAwardNumericDate(expirationDate, locale)}`;
};
